import { TabGroup, TabGroupTitle, TabList, Tab } from "@utahdts/utah-design-system";
import { useEffect } from "react";

const DwriTabs = ({ activeTab, onTabChange }) => {
    useEffect(() => {
        const tabs = document.querySelectorAll('.tab-group__tab-button[aria-selected]');
        tabs.forEach(tab => {
            const val = tab.getAttribute('aria-selected');
            if (val !== "true" && val !== "false") {
                tab.removeAttribute('aria-selected');
            }
        });

        const tabButtons = document.querySelectorAll('.tab-group__tab-button[aria-controls]');
        tabButtons.forEach(tab => {
            const oldControls = tab.getAttribute('aria-controls');
            if (oldControls) {
                let newControls = oldControls.replace(/[^a-zA-Z0-9-_]+/g, '-');
                newControls = newControls.replace(/-+/g, '-');
                newControls = newControls.replace(/^[-\d]+/, '');
                if (!/^[a-zA-Z]/.test(newControls)) {
                    newControls = 'tabpanel-' + newControls;
                }
                tab.setAttribute('aria-controls', newControls);
                const tabPanel = document.getElementById(oldControls);
                if (tabPanel) {
                    tabPanel.id = newControls;
                }
            }
        });
    });

    return (
        <TabGroup value={activeTab} onChange={onTabChange}>
            <TabGroupTitle className="visually-hidden">DWRi Data Navigation</TabGroupTitle>
            <TabList>
                <Tab id="dwri-data">DWRi Data</Tab>
                <Tab id="calculations">Calculations</Tab>
                <Tab id="report">Report</Tab>
            </TabList>
        </TabGroup>
    );
};

export default DwriTabs;